import api from './auth';

// GET /channels/distinct - 获取所有唯一的频道名称（仅 admin）
export const getDistinctChannels = (): Promise<{ data: string[] }> =>
  api.get('/channels/distinct');

// PATCH /channels/users/:userId - 更新用户的频道（仅 admin）
export const updateUserChannel = (userId: number, data: { channelName: string }) =>
  api.patch(`/channels/users/${userId}`, data);

// PATCH /channels/devices/batch - 批量更新设备频道（仅 admin）
export const batchUpdateDeviceChannel = (data: { deviceIds: string[]; channelName: string }) =>
  api.patch('/channels/devices/batch', data);

// PATCH /servers/:deviceId/channel - 更新单个设备的频道
export const updateDeviceChannel = (deviceId: string, data: { channelName: string }) =>
  api.patch(`/servers/${deviceId}/channel`, data);
